import "trix"
import "@rails/actiontext"
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import TurboPower from 'turbo_power'

// Controllers
import { Autocomplete } from "stimulus-autocomplete"
import Timeago from "stimulus-timeago"
import Notification from "stimulus-notification"
import CheckboxSelectAll from "stimulus-checkbox-select-all"
import CharacterCounter from "stimulus-character-counter"

TurboPower.initialize(Turbo.StreamActions)
const application = Application.start()

application.debug = process.env.NODE_ENV === "development"
application.warnings = true
window.Stimulus = application

application.register("timeago", Timeago)
application.register("autocomplete", Autocomplete)
application.register("notification", Notification)
application.register("checkbox-select-all", CheckboxSelectAll)
application.register("character-counter", CharacterCounter)

try {
  const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true })
  registerControllers(application, controllers)
} catch (error) {
  console.error("Error registering Stimulus controllers:", error)
}

import "../channels/index.js"
